interface SectionHeaderProps {
  title: string
  description?: string
  align?: 'left' | 'center'
  as?: 'h1' | 'h2'
}

export function SectionHeader({
  title,
  description,
  align = 'center',
  as: Tag = 'h2',
}: SectionHeaderProps) {
  return (
    <div className={align === 'center' ? 'text-center' : ''}>
      <Tag className="text-2xl font-medium tracking-tight sm:text-3xl md:text-4xl">
        {title}
      </Tag>
      {description && (
        <p className="text-muted-foreground mt-3 text-base sm:mt-4 sm:text-lg">
          {description}
        </p>
      )}
    </div>
  )
}
